import { gql } from '@apollo/client';

export const pageStockItems = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageStockItems(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        assetNumber
        barcode
        description1
        description2
        description3
        additionalRemarks
        additionalRemarks2
        additionalRemarks3
        serialNumber
        status
        requestNumber
        requestItemFYNumber
        requestedItemId
        requestId
        updateId
        deployed
        needsBarcode
        majorEquipmentClass
      }
    }
  }
`;

export const updateNonBarcodeStockMutation = gql`
  mutation ($items: [Float!]!) {
    updateNonBarcodeStock(items: $items)
  }
`;

export const getStockTotals = gql`
  query {
    getStockTotals {
      type
      value
    }
  }
`;
